import { styled } from '@/styled-system/jsx';

export const StyledArrowButton = styled('button', {
  base: {
    background: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'hpxGrey400',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transitionProperty: 'all',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease',
    _hover: {
      background: 'hpxGrey100',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
    },
    _active: {
      transform: 'scale(0.95)',
    },
  },
  variants: {
    isDisabled: {
      true: {
        visibility: 'hidden',
        pointerEvents: 'none',
      },
    },
    position: {
      left: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        left: '-8px',
        zIndex: 10,
        _active: {
          transform: 'translateY(-50%) scale(0.95)',
        },
      },
      right: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: '-8px',
        zIndex: 10,
        _active: {
          transform: 'translateY(-50%) scale(0.95)',
        },
      },
    },
  },
});
